import { render, staticRenderFns } from "./Show-colaborador.vue?vue&type=template&id=1910ca51&scoped=true&"
import script from "./Show-colaborador.vue?vue&type=script&lang=js&"
export * from "./Show-colaborador.vue?vue&type=script&lang=js&"
import style0 from "./Show-colaborador.vue?vue&type=style&index=0&id=1910ca51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1910ca51",
  null
  
)

export default component.exports